import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import Copy from 'Src/components/Copy';
import { Flex } from 'Src/components/layout/Flex';
import CheckActivityRow from 'Src/feature/check/CheckActivityRow';
import { useCurrentCheck } from 'Src/feature/check/useCurrentCheck';
import { buildKeyFromObject } from 'Src/utils/object';

import { Divider } from '../divider/Divider';

import styles from './CheckPageVoided.module.scss';

const sectionId = 'CheckPageVoided';

const CheckPageVoided: FC = () => {
  const { t } = useTranslation();

  const currentCheck = useCurrentCheck();

  return (
    <Flex data-testid={sectionId} className={styles.root} gap="sm">
      <Flex className={styles.activity_root} gap="sm">
        <Divider variant="stubby" />
        <Copy variant="h6" value={t('check.activity')} />
        <Flex gap="xs" className={styles['activity']}>
          {currentCheck.query.data?.activities.map((activity) => (
            <CheckActivityRow key={buildKeyFromObject(sectionId, activity)} activity={activity} check={currentCheck.query.data} />
          ))}
        </Flex>
      </Flex>
    </Flex>
  );
};

export { CheckPageVoided };
